export const DEFAULT_FIELDS_COUNT = 4;
